var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getAxios } from "../httpCommon";
import endPoints from "../../constants/api";
import { getOktaToken } from '../auth/okta';
export var getClientDropdownData = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var configuration, token, axiosInstance, response, error_1;
    var QuickSearch = _b.QuickSearch;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                configuration = {
                    url: import.meta.env.VITE_API_URL_Market_SECURITY + endPoints.API_CLIENT_DROPDOWN,
                    acceptHeader: 'application/vnd.aon.MarketSecurity.SendClientResponse.v1+json',
                    contentType: 'application/json'
                };
                token = getOktaToken();
                _c.label = 1;
            case 1:
                _c.trys.push([1, 4, , 5]);
                return [4 /*yield*/, getAxios(configuration)];
            case 2:
                axiosInstance = _c.sent();
                return [4 /*yield*/, axiosInstance.get(configuration.url, {
                        headers: { "Authorization": "Bearer ".concat(token) },
                        params: {
                            Sort: "Name ASC",
                            QuickSearch: QuickSearch
                        }
                    })];
            case 3:
                response = _c.sent();
                return [2 /*return*/, response];
            case 4:
                error_1 = _c.sent();
                console.error('Error posting client dropdown data:', error_1);
                throw error_1; // Re-throw error after logging it
            case 5: return [2 /*return*/];
        }
    });
}); };
export var getAONStaffDropData = function (search) { return __awaiter(void 0, void 0, void 0, function () {
    var configuration, token, axiosInstance, response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                configuration = {
                    url: import.meta.env.VITE_API_URL_Market_SECURITY + endPoints.API_AON_STAFF_DROPDOWN,
                    acceptHeader: 'application/vnd.aon.MarketSecurity.SendColleagueResponse.v1+json',
                    contentType: 'application/json'
                };
                token = getOktaToken();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, getAxios(configuration)];
            case 2:
                axiosInstance = _a.sent();
                return [4 /*yield*/, axiosInstance.get(configuration.url, {
                        headers: { "Authorization": "Bearer ".concat(token) },
                        params: {
                            search: search
                        }
                    })];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response];
            case 4:
                error_2 = _a.sent();
                console.error('Error posting client dropdown data:', error_2);
                throw error_2; // Re-throw error after logging it
            case 5: return [2 /*return*/];
        }
    });
}); };
export var getAONStaffTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
    var configuration, token, axiosInstance, response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                configuration = {
                    url: import.meta.env.VITE_API_URL_Market_SECURITY + endPoints.API_AON_STAFF_TYPES,
                    acceptHeader: 'application/vnd.aon.MarketSecurity.SendLookupResponse.v1+json',
                    contentType: 'application/json'
                };
                token = getOktaToken();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, getAxios(configuration)];
            case 2:
                axiosInstance = _a.sent();
                return [4 /*yield*/, axiosInstance.get(configuration.url, {
                        headers: { "Authorization": "Bearer ".concat(token) },
                    })];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response];
            case 4:
                error_3 = _a.sent();
                console.error('Error posting client dropdown data:', error_3);
                throw error_3; // Re-throw error after logging it
            case 5: return [2 /*return*/];
        }
    });
}); };
export var handleAONStaffCrud = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var configuration, token, axiosInstance, response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                configuration = {
                    url: import.meta.env.VITE_API_URL_Market_SECURITY + endPoints.API_AON_STAFF_CRUD,
                    acceptHeader: 'text/plain',
                    contentType: 'application/json'
                };
                token = getOktaToken();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, getAxios(configuration)];
            case 2:
                axiosInstance = _a.sent();
                return [4 /*yield*/, axiosInstance.post(configuration.url, body, {
                        headers: { "Authorization": "Bearer ".concat(token) },
                    })];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response];
            case 4:
                error_4 = _a.sent();
                console.error('Error in AON STAFF ADD/Delete/Update:', error_4);
                throw error_4; // Re-throw error after logging it
            case 5: return [2 /*return*/];
        }
    });
}); };
//Using fetch for Client Add and Remove
/*
export const handleClientAddOperation = async (body: IClientAccountAddBody) => {
    try {
        const RequestURL = import.meta.env.VITE_API_URL_UNITED_REINSURANCE + endPoints.API_CLIENT_STAFF_ADD;
        const response = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Appian-API-Key": import.meta.env.APPIAN_API_KEY,

            },
            body: JSON.stringify(body)
        });
        return response;
    } catch (error) {
        console.error('Error In Client staff ADD API call:', error);
        throw error; // Re-throw error after logging it
    }
}

*/
/*
export const addNewClient = async (body: IAddNewClient) => {
    try {
        const RequestURL = import.meta.env.VITE_API_URL_UNITED_REINSURANCE + endPoints.API_CLIENT_STAFF_ADD;
        const response = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Appian-API-Key": import.meta.env.APPIAN_API_KEY,

            },
            body: JSON.stringify(body)
        });
        return response;
    } catch (error) {
        console.error('Error In Client staff ADD API call:', error);
        throw error; // Re-throw error after logging it
    }
}

*/
/*
export const handleClientStaffRemove = async (body: IClientAccountRemoveBody[]) => {
    try {
        const RequestURL = import.meta.env.VITE_API_URL_UNITED_REINSURANCE + endPoints.API_CLIENT_STAFF_ADD;
        const response = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Appian-API-Key": import.meta.env.APPIAN_API_KEY,

            },
            body: JSON.stringify(body)
        });
        return response;
    } catch (error) {
        console.error('Error in Client STAFF Remove:', error);
        throw error; // Re-throw error after logging it
    }
}
*/
/*
export const handleAddNewMarket = async (body: any) => {
    try {
        const RequestURL = import.meta.env.VITE_API_URL_UNITED_REINSURANCE + endPoints.API_CLIENT_STAFF_ADD;
        const response = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Appian-API-Key":import.meta.env.APPIAN_API_KEY
            },
            body: JSON.stringify(body)
        });
        return response;
    } catch (error) {
        console.error('Error In Add new Market API call:', error);
        throw error; // Re-throw error after logging it
    }
}
*/
/*
export const handleClientAddRemoveChange = async (body: any) => {
    try {
        const RequestURL = import.meta.env.VITE_API_URL_UNITED_REINSURANCE + endPoints.API_CLIENT_STAFF_ADD;
        const response = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Appian-API-Key": import.meta.env.APPIAN_API_KEY
            },
            body: JSON.stringify(body)
        });
        return response;
    } catch (error) {
        console.error('Error In Add new Client API call:', error);
        throw error; // Re-throw error after logging it
    }
}

*/
// new Modified api call Functions
export var handleClientAddRemoveChange = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var configuration, axiosInstance, response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                configuration = {
                    url: import.meta.env.VITE_API_URL_Mrv + endPoints.API_SEND_CLIENT_REQUEST,
                    acceptHeader: 'application/json',
                    contentType: 'application/json',
                };
                return [4 /*yield*/, getAxios(configuration)];
            case 1:
                axiosInstance = _a.sent();
                return [4 /*yield*/, axiosInstance.get(configuration.url, {
                        headers: {
                            'Content-Type': 'application/json',
                            //"Appian-API-Key": import.meta.env.APPIAN_API_KEY
                        },
                        params: body
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response];
            case 3:
                error_5 = _a.sent();
                console.error('Error In Add new Client API call:', error_5);
                throw error_5; // Re-throw error after logging it
            case 4: return [2 /*return*/];
        }
    });
}); };
export var addNewClient = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var configuration, axiosInstance, response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                configuration = {
                    url: import.meta.env.VITE_API_URL_Mrv + endPoints.API_SEND_CLIENT_REQUEST,
                    acceptHeader: 'application/json',
                    contentType: 'application/json',
                };
                return [4 /*yield*/, getAxios(configuration)];
            case 1:
                axiosInstance = _a.sent();
                return [4 /*yield*/, axiosInstance.get(configuration.url, {
                        headers: {
                            'Content-Type': 'application/json',
                            //"Appian-API-Key": import.meta.env.APPIAN_API_KEY
                        },
                        params: body
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response];
            case 3:
                error_6 = _a.sent();
                console.error('Error In Client staff ADD API call:', error_6);
                throw error_6; // Re-throw error after logging it
            case 4: return [2 /*return*/];
        }
    });
}); };
export var handleAddNewMarket = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var configuration, axiosInstance, response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                configuration = {
                    url: import.meta.env.VITE_API_URL_Mrv + endPoints.API_SEND_CLIENT_REQUEST,
                    acceptHeader: 'application/json',
                    contentType: 'application/json',
                };
                return [4 /*yield*/, getAxios(configuration)];
            case 1:
                axiosInstance = _a.sent();
                return [4 /*yield*/, axiosInstance.get(configuration.url, {
                        headers: {
                            'Content-Type': 'application/json',
                            //"Appian-API-Key": import.meta.env.APPIAN_API_KEY
                        },
                        params: body
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response];
            case 3:
                error_7 = _a.sent();
                console.error('Error In Add new Market API call:', error_7);
                throw error_7; // Re-throw error after logging it
            case 4: return [2 /*return*/];
        }
    });
}); };
export var handleClientAddOperation = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var configuration, axiosInstance, response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                configuration = {
                    url: import.meta.env.VITE_API_URL_Mrv + endPoints.API_SEND_CLIENT_REQUEST,
                    acceptHeader: 'application/json',
                    contentType: 'application/json',
                };
                return [4 /*yield*/, getAxios(configuration)];
            case 1:
                axiosInstance = _a.sent();
                return [4 /*yield*/, axiosInstance.get(configuration.url, {
                        headers: {
                            'Content-Type': 'application/json',
                            //"Appian-API-Key": import.meta.env.APPIAN_API_KEY
                        },
                        params: body
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response];
            case 3:
                error_8 = _a.sent();
                console.error('Error In Client staff ADD API call:', error_8);
                throw error_8; // Re-throw error after logging it
            case 4: return [2 /*return*/];
        }
    });
}); };
export var handleClientStaffRemove = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var configuration, axiosInstance, response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                configuration = {
                    url: import.meta.env.VITE_API_URL_Mrv + endPoints.API_SEND_CLIENT_REQUEST,
                    acceptHeader: 'application/json',
                    contentType: 'application/json',
                };
                return [4 /*yield*/, getAxios(configuration)];
            case 1:
                axiosInstance = _a.sent();
                return [4 /*yield*/, axiosInstance.get(configuration.url, {
                        headers: {
                            'Content-Type': 'application/json',
                            //"Appian-API-Key": import.meta.env.APPIAN_API_KEY
                        },
                        params: body
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response];
            case 3:
                error_9 = _a.sent();
                console.error('Error in Client STAFF Remove:', error_9);
                throw error_9; // Re-throw error after logging it
            case 4: return [2 /*return*/];
        }
    });
}); };
